import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { NavigationHistoryService } from 'src/app/ui/navigation-history.service';
import { RoutePath } from './enumerable/route-path.enum';

const SIDEBAR_COLLAPSED_KEY = 'epago-console-sidebar-collapsed';

@Component({ standalone: false,
    selector: 'app-sidenav-wrapper',
    templateUrl: './sidenav-wrapper.component.html',
    styleUrls: ['./sidenav-wrapper.component.scss'],
})
export class SidenavWrapperComponent implements OnInit, OnDestroy {
    readonly docsUrl = 'https://docs.epago.pe/';

    isMenuOpen = false;
    sidebarCollapsed = false;
    private routerSub?: Subscription;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navHistory: NavigationHistoryService,
    ) {
        try {
            this.sidebarCollapsed = localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
        } catch {
            this.sidebarCollapsed = false;
        }
    }

    ngOnInit(): void {
        this.trackRoute(this.router.url);
        this.routerSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((e) => {
                this.trackRoute(e.urlAfterRedirects);
                this.closeMenu();
            });
    }

    ngOnDestroy(): void {
        this.routerSub?.unsubscribe();
    }

    private trackRoute(url: string): void {
        const path = url.split('?')[0].split('#')[0];
        this.navHistory.record(path);
    }

    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }

    toggleSidebarCollapse(): void {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        try {
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, this.sidebarCollapsed ? '1' : '0');
        } catch {
            /* ignore */
        }
    }

    closeMenu(): void {
        this.isMenuOpen = false;
    }

    onNavClick(): void {
        this.closeMenu();
    }

    logout(): void {
        localStorage.clear();
        this.goToPath(`${RoutePath.LOGIN}`);
    }

    private goToPath(path: string): void {
        this.router.navigate([path], {
            relativeTo: this.activatedRoute.parent?.parent,
        });
    }
}
